import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ApiError } from "../../api/client";
import { useUpdateProfile } from "../../api/account";
import { useAuth } from "../../auth/AuthProvider";
import { useActiveCar } from "../../auth/useActiveCar";
import Icon from "../../components/Icon";

import ImportFuelCsvModal from "./ImportFuelCsvModal";

export default function AccountSettingsPage() {
  const navigate = useNavigate();
  const { me } = useAuth();
  const { activeCar } = useActiveCar();
  const update = useUpdateProfile();
  const [error, setError] = useState<string | null>(null);
  const [importOpen, setImportOpen] = useState(false);

  if (!me) {
    return (
      <section className="page-section">
        <p className="empty-state">Loading...</p>
      </section>
    );
  }

  async function handleLanguageChange(value: string) {
    setError(null);
    try {
      await update.mutateAsync({ language: value });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not save.");
    }
  }

  async function handleEasterEggChange(value: boolean) {
    setError(null);
    try {
      await update.mutateAsync({ fuel_pump_easter_egg: value });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not save.");
    }
  }

  return (
    <section className="page-section">
      <div className="car-detail-nav">
        <button
          type="button"
          className="button button--ghost button--small"
          onClick={() => navigate("/account")}
        >
          ← Back to Account
        </button>
      </div>

      <header className="page-header">
        <h1 className="page-header__title">Settings</h1>
      </header>

      <div className="account-settings">
        <label className="form-row">
          <span className="form-row__label">Language</span>
          <select
            className="form-row__input"
            value={me.language}
            onChange={(e) => handleLanguageChange(e.target.value)}
            disabled={update.isPending}
          >
            <option value="en">English</option>
          </select>
        </label>
        <label className="form-row">
          <span className="form-row__label">Fuel pump</span>
          <select
            className="form-row__input"
            value={me.fuel_pump_easter_egg ? "on" : "off"}
            onChange={(e) => handleEasterEggChange(e.target.value === "on")}
            disabled={update.isPending}
          >
            <option value="on">On</option>
            <option value="off">Off</option>
          </select>
        </label>
      </div>
      {error ? <p className="form-error">{error}</p> : null}

      <ul className="account-menu account-settings__actions" aria-label="Settings options">
        <li>
          <button
            type="button"
            className="account-menu__row account-menu__row--action"
            onClick={() => setImportOpen(true)}
          >
            <span className="account-menu__lead">
              <Icon name="import" className="account-menu__icon" />
              <span className="account-menu__label">Import fuel records</span>
            </span>
          </button>
        </li>
      </ul>

      <ImportFuelCsvModal
        isOpen={importOpen}
        onClose={() => setImportOpen(false)}
        defaultCarId={activeCar?.id ?? null}
      />
    </section>
  );
}
